"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticate = authenticate;
var _authentication = require("../../types/authentication");
var _action_types = require("../../constants/action_types");
var _validate = require("../../api/validate");
var _jsonpRequest = require("../../../browser/utils/jsonpRequest");
var _events = require("../../types/events");
var _view = require("../../types/view");
var _view2 = require("../view");
var _tracking = require("../../utils/tracking");
var _validation = require("../../utils/validation");
var _rememberedAccounts = require("../../utils/rememberedAccounts");
var _rememberedAccounts2 = require("../../types/rememberedAccounts");
function authenticate(_ref) {
  let {
    persistent,
    phone,
    code
  } = _ref;
  return async (dispatch, getState, context) => {
    dispatch({
      status: _authentication.EAuthenticateStatus.Loading,
      type: _action_types.AUTHENTICATION_AUTHENTICATE_TYPE
    });
    const {
      login: username,
      authentication: {
        password
      },
      isRememberAccountsFlow,
      source
    } = getState();
    try {
      const response = await (0, _validate.validate)(context.httpApi, {
        login: username,
        password,
        phone,
        code
      });
      if (response.statusCode === 200) {
        const login = response.response.login || '';
        const logOnInfo = response.response.logOnInfo || [];
        try {
          await Promise.all(logOnInfo.map(info => (0, _jsonpRequest.jsonpRequest)(`${info.logOnUrl}?` + `login=${encodeURIComponent(login)}&` + `token=${info.token}&` + `persistent=${persistent || true}`)));
          dispatch({
            status: _authentication.EAuthenticateStatus.Succeed,
            type: _action_types.AUTHENTICATION_AUTHENTICATE_TYPE
          });
          context.emitter.emit(_events.EEventType.AuthenticateSucceed, {
            isTwoFactor: !!code
          });
          if (code) {
            (0, _tracking.trackAuthenticateSuccess)({
              socialType: phone ? 'phone_code' : 'email_code',
              source
            });
          } else {
            (0, _tracking.trackAuthenticateSuccess)({
              socialType: (0, _validation.isEmail)(username) ? 'email' : 'id',
              source
            });
          }
          if (isRememberAccountsFlow) {
            (0, _rememberedAccounts.saveAccount)({
              type: _rememberedAccounts2.ERememberedAccountType.Email,
              value: username
            });
          }
        } catch (e) {
          context.logger.error(e, {
            domain: 'auth-widget.api.authenticate#logon'
          });
          dispatch({
            type: _action_types.AUTHENTICATION_AUTHENTICATE_TYPE,
            status: _authentication.EAuthenticateStatus.Failed,
            errorType: _authentication.EAuthenticateError.Unexpected,
            error: 'Произошла непредвиденная ошибка'
          });
        }
        return;
      } else if (response.statusCode === 429) {
        dispatch({
          type: _action_types.AUTHENTICATION_AUTHENTICATE_TYPE,
          status: _authentication.EAuthenticateStatus.Failed,
          errorType: _authentication.EAuthenticateError.LimitReached,
          error: 'Превышен лимит попыток авторизации. Попробуйте позже'
        });
        return;
      } else if (response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(error => error.code.includes('needCheckCode'))) {
        const error = response.response.errors.find(error => error.code.includes('needCheckCode'));
        const isTwoFactoryByEmail = Boolean(error && error.code === 'needCheckCodeByEmail');
        dispatch({
          type: _action_types.AUTHENTICATION_AUTHENTICATE_TYPE,
          status: _authentication.EAuthenticateStatus.Failed,
          errorType: _authentication.EAuthenticateError.TwoFactorRequired,
          error: response.response.message
        });

        // Для пользователей с виртуальными номерами, сразу отображаем экран ввода кода подтверждения
        if (isTwoFactoryByEmail) {
          dispatch((0, _view2.changeView)(_view.EActiveView.TwoFactorWithEmail));
        } else {
          dispatch((0, _view2.changeView)(_view.EActiveView.TwoFactorWithPhone));
        }
        const type = isTwoFactoryByEmail ? _authentication.ETwoFactorType.Email : _authentication.ETwoFactorType.Phone;
        context.emitter.emit(_events.EEventType.TwoFactorRequired, {
          type
        });
        return;
      } else if (response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(error => error.code === 'invalidConfirmationCode')) {
        context.emitter.emit(_events.EEventType.TwoFactorInvalid);
        (0, _tracking.trackTwoFactorInvalid)(!phone ? _authentication.ETwoFactorType.Email : _authentication.ETwoFactorType.Phone);
      } else if (response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(error => error.code === 'confirmationCodeInputLimitReached')) {
        dispatch({
          type: _action_types.AUTHENTICATION_AUTHENTICATE_TYPE,
          status: _authentication.EAuthenticateStatus.Failed,
          errorType: _authentication.EAuthenticateError.TwoFactorAttemptsExhausted,
          error: response.response.message
        });
        dispatch((0, _view2.changeView)(_view.EActiveView.TwoFactorAttemptsExhausted, {
          phone
        }));
        context.emitter.emit(_events.EEventType.TwoFactorAttemptsExhausted, {
          phone
        });
        (0, _tracking.trackTwoFactorAttemptsExhaustedPopupOpen)(!phone ? _authentication.ETwoFactorType.Email : _authentication.ETwoFactorType.Phone);
        return;
      }
      const error = response.response.errors.length > 0 ? response.response.errors[0].message : response.response.message;
      dispatch({
        type: _action_types.AUTHENTICATION_AUTHENTICATE_TYPE,
        status: _authentication.EAuthenticateStatus.Failed,
        errorType: _authentication.EAuthenticateError.Common,
        error
      });
    } catch (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.authenticate'
      });
      dispatch({
        type: _action_types.AUTHENTICATION_AUTHENTICATE_TYPE,
        status: _authentication.EAuthenticateStatus.Failed,
        errorType: _authentication.EAuthenticateError.Unexpected,
        error: 'Произошла непредвиденная ошибка'
      });
    }
  };
}